import { Divider, Skeleton } from '@heroui/react';
import { Container } from '@school-manage/ui/Container/Container';
import { HeaderBar } from '@school-manage/ui/HeaderBar/HeaderBar';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export function NewsDetailSkeleton() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <HeaderBar
        backBtnHandler={() => navigate({ to: '/news' })}
        hasBackBtn
        title={t('news')}
      />
      <Container hasNavigationGap={false}>
        <div className="flex flex-col gap-2">
          <Skeleton className="h-6 w-2/3 rounded-lg" />
          <Skeleton className="h-6 w-2/3 rounded-lg" />
          <Skeleton className="h-6 w-2/3 rounded-lg" />
        </div>

        {/* 发布时间 */}
        <Skeleton className="h-4 w-1/4 rounded-lg" />

        <Divider className="h-px" />

        {/* 内容 */}
        <div className="flex flex-col gap-2">
          <Skeleton className="h-4 rounded-lg" />
          <Skeleton className="h-4 rounded-lg" />
          <Skeleton className="h-4 rounded-lg" />
          <Skeleton className="h-4 rounded-lg" />
        </div>
      </Container>
    </>
  );
}
